import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormGroupDirective,
} from '@angular/forms';

import { Subscription } from 'rxjs';

@Component({
  selector: 'app-easy-opening-hours-subform',
  templateUrl: './easy-opening-hours-subform.component.html',
  styleUrls: ['./easy-opening-hours-subform.component.scss'],
})
export class EasyOpeningHoursSubformComponent implements OnInit, OnDestroy {
  @Input() formGroupName!: string;

  subs = new Subscription();
  form!: UntypedFormGroup;

  DAYS = 'SHARED.OPENING_HOURS.DAYS.';
  DAY = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ];
  daysEnabled: { [key: string]: boolean } = {};
  hours: string[] = [];

  constructor(private rootFormGroup: FormGroupDirective) {}

  ngOnInit(): void {
    if (!this.formGroupName) {
      throw Error('Attribute "formGroupName" is required');
    }
    this.form = this.rootFormGroup.control.get(
      this.formGroupName
    ) as UntypedFormGroup;

    this.subs.add(
      this.form.valueChanges.subscribe(() => {
        this.DAY.forEach((day) => {
          const enabled = !!this.form.get(day)?.value.from;
          this.daysEnabled[day] = enabled;
          if (!enabled && this.form.get(day)?.enabled) {
            this.form.get(day)?.disable({ emitEvent: false });
          } else if (enabled && this.form.get(day)?.disabled) {
            this.form.get(day)?.enable({ emitEvent: false });
          }
        });
      })
    );
    this.fillHours();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  remove(day: string): void {
    const form = this.form.get(day);
    if (form) {
      form.setValue(null);
      form.markAsDirty();
    }
  }

  add(day: string): void {
    const form = this.form.get(day);
    if (form) {
      form.setValue({ from: '08:00', to: '16:00' });
      form.markAsDirty();
    }
  }

  fillHours() {
    for (let i = 0; i < 24; i++) {
      if (i < 10) {
        this.hours.push(`0${i}:00`);
        this.hours.push(`0${i}:15`);
        this.hours.push(`0${i}:30`);
        this.hours.push(`0${i}:45`);
      } else {
        this.hours.push(`${i}:00`);
        this.hours.push(`${i}:15`);
        this.hours.push(`${i}:30`);
        this.hours.push(`${i}:45`);
      }
    }
  }

  dayForm(day: string): UntypedFormGroup {
    return this.form.get(day) as UntypedFormGroup;
  }

  toggleDay(day: string, event: any) {
    if (event.checked) {
      this.form.get(day)?.enable({ emitEvent: false });
      this.form
        .get(day)
        ?.setValue({ from: '08:00', to: '16:00' }, { emitEvent: false });
    } else {
      this.form
        .get(day)
        ?.setValue({ from: null, to: null }, { emitEvent: false });
      this.form.get(day)?.disable({ emitEvent: false });
    }
  }
}
